import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import logoMark from "@/assets/logo-mark.png";

// Página aberta depois que o usuário clica no link de confirmação de e-mail
// (GET /api/auth/confirm-email/{token} no backend redireciona pra cá). Nesse ponto a
// sessão já foi criada e o cookie já foi setado pelo próprio redirect do backend —
// então essa tela só existe pra dar um retorno visual claro (antes ficava em branco,
// indo direto pro Painel) e levar pro Painel em seguida, sem exigir login de novo.
export default function EmailConfirmado() {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(4);

  useEffect(() => {
    if (seconds <= 0) {
      navigate("/dashboard", { replace: true });
      return;
    }
    const t = setTimeout(() => setSeconds((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [seconds, navigate]);

  return (
    <div className="min-h-screen flex flex-col justify-center px-6 py-16 bg-white">
      <div className="w-full max-w-sm mx-auto text-center space-y-6">
        <div className="flex items-center gap-2 justify-center">
          <img src={logoMark} alt="" className="w-9 h-9 rounded-md" />
          <span className="font-display text-xl font-bold"><span className="text-gold-600">IA</span>pauta</span>
        </div>

        <div className="w-14 h-14 rounded-full bg-gold-500/15 border border-gold-500/25 flex items-center justify-center mx-auto">
          <CheckCircle2 className="w-7 h-7 text-emerald-brand" strokeWidth={1.75} />
        </div>

        <div className="space-y-2">
          <h1 className="font-display text-2xl font-bold text-stone-900">E-mail confirmado!</h1>
          <p className="text-sm text-stone-500 leading-relaxed">
            Sua conta está ativa e você já entrou automaticamente — não precisa digitar
            senha de novo.
          </p>
        </div>

        <Button
          data-testid="go-to-dashboard-button"
          onClick={() => navigate("/dashboard", { replace: true })}
          className="w-full h-11 bg-emerald-brand text-white font-medium rounded-md"
        >
          Ir para o Painel
        </Button>

        <p className="text-xs text-stone-400">
          Você será levado pra lá automaticamente em {seconds}s.
        </p>
      </div>
    </div>
  );
}
